export const APP_DATA_DB_NAME = "overmap-app"
